import { createFileRoute } from "@tanstack/react-router";
import IbxInsurance, { config } from "@/pages/IbxInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/ibx-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "IBX TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Independence Blue Cross coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification for depression treatment in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "IBX TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Independence Blue Cross coverage for TMS, SAINT TMS, and SPRAVATO. Benefits verification for depression treatment in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/ibx-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/ibx-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <IbxInsurance />;
}
